module.exports = __webpack_public_path__ + "static/img/img_12.d4443d04.png";